import Swiper from 'swiper';
import { Scrollbar, FreeMode } from 'swiper/modules';
import 'swiper/scss';

export default function (element, data) {
    element.swiper = new Swiper(element, {
        modules: [Scrollbar, FreeMode],
        slidesPerView: 1,
        spaceBetween: 40,
        freeMode: true,
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
        },
        breakpoints: {
            600: {
                slidesPerView: 2,
            },
            900: {
              slidesPerView: 3,
            }
        }
    });
};

// @widgetLoadingMode:lazy-once
// @widgetLoadingChunk:secondary